import React from 'react';

const TOKEN = /(https?:\/\/[^\s]+|[\w.+-]+@[\w-]+\.[\w.-]+)/g;

/** Plain text with URLs and email addresses turned into links. */
const Linkify = ({ text }) => String(text || '').split(TOKEN).map((part, i) => {
  if (!part) return null;
  if (/^https?:\/\//.test(part)) {
    return <a key={i} href={part} target="_blank" rel="noreferrer" className="text-blue-600 underline-offset-2 hover:underline">{part}</a>;
  }
  if (/^[\w.+-]+@[\w-]+\.[\w.-]+$/.test(part)) {
    return <a key={i} href={`mailto:${part}`} className="text-blue-600 underline-offset-2 hover:underline">{part}</a>;
  }
  return <React.Fragment key={i}>{part}</React.Fragment>;
});

export default Linkify;
